import { Action, createReducer, on } from '@ngrx/store';

import { PlaceType } from '@shared/base-search-bar/entities/place-type';
import {
  selectArrivalPlaceAction,
  selectDeparturePlaceAction,
  selectDestinationPlaceAction
} from '@shared/base-search-bar/store/actions/search-bar.actions';

export const initialState = null;

const featureReducer = createReducer(
  initialState,
  on(
    selectArrivalPlaceAction,
    selectDestinationPlaceAction,
    () => PlaceType.ARRIVAL
  ),
  on(selectDeparturePlaceAction, () => PlaceType.DEPARTURE)
);

export const placeTypeSelectedReducer = (state: boolean, action: Action): PlaceType => {
  return featureReducer(state, action);
};
